import React from 'react';
import { Components } from './styled';
import { getTextFromSelectedItems } from '../../hooks/useSearchDropdown';
import ProjectSearchDropdown from '../ProjectSearchDropdown';

const FiltersComponent = ({
  filtersDropdownProps,
}: {
  filtersDropdownProps: { pillarType: any; goal: any; category: any };
}) => {
  const renderPicker = (title: string, props: any) => {
    return (
      <Components.FieldWrapper>
        <Components.FieldLabel>{title}</Components.FieldLabel>
        <Components.Picker onClick={(e) => props.show(e)}>
          {props?.selectedItems && props?.selectedItems?.length > 0 ? (
            <Components.PickerLabel>{getTextFromSelectedItems(props?.selectedItems)}</Components.PickerLabel>
          ) : (
            <Components.NotSetLabel>Not set</Components.NotSetLabel>
          )}
          <Components.PickerIconWrapper>
            <Components.PickerIcon />
          </Components.PickerIconWrapper>
        </Components.Picker>
        <ProjectSearchDropdown {...props} />
      </Components.FieldWrapper>
    );
  };

  return (
    <Components.Container>
      {renderPicker('Pillars', filtersDropdownProps.pillarType)}
      {renderPicker('Goals', filtersDropdownProps.goal)}
      {renderPicker('Categories', filtersDropdownProps.category)}
    </Components.Container>
  );
};

export default FiltersComponent;
